import React from "react";
import { BadgeCheckIcon, Building2Icon, CalendarCheckIcon, HomeIcon, StarIcon } from "lucide-react";
import { MarineEmblem } from "./MarineEmblem";
export type BadgeKey = "veteran" | "chamber" | "local" | "licensed" | "since" | "google";
type TrustBadgeProps = {
  badgeKey: BadgeKey;
  label: string;
  tone?: "light" | "dark";
};
export function TrustBadge({
  badgeKey,
  label,
  tone = "light"
}: TrustBadgeProps) {
  const onDark = tone === "dark";
  const iconCls = "h-6 w-6";
  const icon = {
    veteran: <MarineEmblem className="h-7 w-7" data-id="element-72" data-mp="278t6tmyqwxei" />,
    chamber: <Building2Icon className={iconCls} strokeWidth={1.5} data-id="element-73" data-mp="27am8soyeytg6" />,
    local: <HomeIcon className={iconCls} strokeWidth={1.5} data-id="element-74" data-mp="1sky7hnq8fusg" />,
    licensed: <BadgeCheckIcon className={iconCls} strokeWidth={1.5} data-id="element-75" data-mp="1xi6t5yalagyg" />,
    since: <CalendarCheckIcon className={iconCls} strokeWidth={1.5} data-id="element-76" data-mp="1xgdkyekbvooc" />,
    google: <StarIcon className={iconCls} strokeWidth={1.5} data-id="element-77" data-mp="1jjgw2inrsha3" />
  }[badgeKey];
  return <div className="flex items-center gap-3" data-id="element-78" data-mp="1oh0dfrfrla69">
      <span className={`grid h-12 w-12 shrink-0 place-items-center rounded-full border ${onDark ? "border-gold/40 text-gold-soft" : "border-gold/50 bg-white text-gold-hover"}`} aria-hidden="true" data-id="element-79" data-mp="1ojutz7vnqaue">
        {icon}
      </span>
      <span className={`text-sm font-medium leading-snug ${onDark ? "text-white/85" : "text-navy"}`} data-id="element-80" data-mp="obgqid1i0i3w">{label}</span>
    </div>;
}